import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';

@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('ipapi.co')) {
      return next.handle(request);
    }
    const newRequest = request.clone({
      headers: request.headers.set('X-Timezone-Offset', this.getTimezoneOffset()),
    });

    return next.handle(newRequest);
  }

  private getTimezoneOffset(): string {
    return String(moment().utcOffset());
  }
}
